/* iurop-recently-viewed — visto recientemente (Apodemia)
 * Guarda los handles visitados en localStorage y pide la propia sección vía
 * /search?section_id=...&q=handle:a OR handle:b (Section Rendering API): las
 * cards llegan renderizadas server-side con iurop-product-card (quick-add
 * incluido). Ordena según el historial y oculta la sección si no hay nada.
 * Escrito a mano (no generado). */
(function () {
  'use strict';

  var KEY = 'apodemia:recently-viewed';
  var MAX_STORED = 12;

  function readStore() {
    try {
      var v = JSON.parse(localStorage.getItem(KEY));
      return Array.isArray(v) ? v : [];
    } catch (e) {
      return [];
    }
  }

  function writeStore(handles) {
    try {
      localStorage.setItem(KEY, JSON.stringify(handles.slice(0, MAX_STORED)));
    } catch (e) { /* almacenamiento lleno/bloqueado: sin historial */ }
  }

  function init(root) {
    var current = root.getAttribute('data-current-handle');
    var handles = readStore();

    // Registra el producto actual (delante, sin duplicar)
    if (current) {
      handles = [current].concat(handles.filter(function (h) { return h !== current; }));
      writeStore(handles);
    }

    // A mostrar: el historial sin el producto actual
    var toShow = handles
      .filter(function (h) { return h !== current; })
      .slice(0, parseInt(root.getAttribute('data-limit') || '8', 10));
    if (!toShow.length) return; // la sección queda oculta

    var root_url = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var q = toShow.map(function (h) { return 'handle:' + h; }).join(' OR ');
    var url =
      root_url + 'search?section_id=' + encodeURIComponent(root.getAttribute('data-section-id')) +
      '&type=product&options[unavailable_products]=last&q=' + encodeURIComponent(q);

    fetch(url)
      .then(function (r) { return r.ok ? r.text() : Promise.reject(r.status); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var items = doc.querySelectorAll('[data-rv-item]');
        if (!items.length) return;

        // Reordena según el historial (más reciente primero)
        var byHandle = {};
        items.forEach(function (el) { byHandle[el.getAttribute('data-handle')] = el; });
        var track = root.querySelector('[data-rv-track]');
        toShow.forEach(function (h) {
          if (byHandle[h]) track.appendChild(byHandle[h]);
        });
        if (track.children.length) root.hidden = false;
      })
      .catch(function () { /* sin resultados: la sección queda oculta */ });
  }

  function initAll() {
    document.querySelectorAll('[data-recently-viewed]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-recently-viewed]');
    if (root) init(root);
  });
})();
